export const CurrencySelect = ({ value, onChange }) => (
  <select value={value || "EUR"} onChange={(e) => onChange(e.target.value)}>
    <option value="EUR">EUR</option>
    <option value="MAD">MAD</option>
    <option value="TND">TND</option>
  </select>
);
